/**
 * Sidebar Date created filter: binds RmaListFiltersStore date range, Mixpanel, and chip label
 * formatting to RmaListFilterControl via filterControlDataProps.
 */
import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { useDateTimeFormattingParams } from "../../../../../hooks/use-datetime-formatting-params";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import RmaListFiltersStore from "../../../rma-list-page/stores/rma-list-filters-store";
import { RMA_LIST_FILTER_CONTROL_DATA_TYPE } from "../rma-list-filter-control/rma-list-filter-control-portal/rma-list-filter-control-content/rma-list-filter-control-content";
import RmaListFilterControl from "../rma-list-filter-control/rma-list-filter-control";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled?: boolean;
}

const RmaListFilterDateRange: React.FC<IProps> = observer(({ rmaListFiltersStore, disabled }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const { timeZone } = useDateTimeFormattingParams();
    const dateRange = rmaListFiltersStore.dateRange;
    const selectedLabel = rmaListFiltersStore.getDateRangeSelectedChipLabel(timeZone);

    return (
        <RmaListFilterControl
            label={getTranslation("DATE_CREATED", scope)}
            selectedLabel={selectedLabel}
            disabled={disabled}
            onOpen={() => rmsMixpanelStore.trackEvent("d&_filter_date_created")}
            onClear={() => rmaListFiltersStore.setDateRange("")}
            filterControlDataProps={{
                type: RMA_LIST_FILTER_CONTROL_DATA_TYPE.DATE_RANGE,
                value: dateRange,
                timeZone,
                getInputValues: rmaListFiltersStore.getDateRangeInputValues,
                onChange: (isoRange) => {
                    rmaListFiltersStore.setDateRange(isoRange);
                    rmsMixpanelStore.trackEvent("d&_apply_date_filter");
                },
            }}
        />
    );
});

export default RmaListFilterDateRange;
